import React, { forwardRef } from "react";
import Img from "./Img";
import useImageFallback from "../hooks/useImageFallback";

const ImgOptimized = forwardRef(({ src, isLazy, onError, ...props }, ref) => {
  const { currentSrc, handleError } = useImageFallback(src, {
    onFinalError: onError,
  });

  if (isLazy) {
    return <Img ref={ref} src={src} onError={onError} {...props} />;
  }
  return <img ref={ref} src={currentSrc} {...props} onError={handleError} />;
});
export default ImgOptimized;
